import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var BookSvg = function BookSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.116 18.76v-4.65H5.721v4.65zM13.628 18.76v-2.79h-1.395v2.79zM19.21 15.04v3.72h-1.396v-3.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.837 2.249H2v20h20V4.109h-6.977v1.86h-4.186zM9.442 20.854H3.395V3.644h6.047zm5.581 0h-4.186V7.365h4.186zm5.582 0h-4.186V5.504h4.186z",
    clipRule: "evenodd"
  }));
};
export var Book = function Book(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: BookSvg
  }));
};